import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, RectangularButton } from '@resideo/blueprint-react';
import ModalHeader from 'components/common/ModalHeader';
import Typography from 'components/common/Typography';
import Link from 'components/common/Link';

const { Text } = Typography;

type MFAEnrollmentDialogProps = {
  Modal: React.ComponentType<any>;
  closeModal: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
};

const MFAEnrollmentDialog: FC<MFAEnrollmentDialogProps> = ({
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Modal is a component reference
  Modal,
  closeModal,
  onConfirm,
  isSubmitting,
}) => {
  const { t } = useTranslation();

  return (
    <Modal>
      <ModalHeader
        data-test-mfa-enroll-modal-close-btn
        title={t('signInSecurity.mfa.enrollDialog.title')}
        textAlign='center'
        closeModal={closeModal}
      />
      <Text
        data-test-mfa-enroll-modal-window-instruction
        marginTop='medium'
        paddingLeft='2rem'
        paddingRight='2rem'
        textAlign='center'>
        {t('signInSecurity.mfa.enrollDialog.windowInstruction')}
      </Text>
      <Flex flexDirection='column' padding='large'>
        <RectangularButton
          data-test-mfa-enroll-modal-confirm-btn
          type='button'
          variant='primary'
          disabled={isSubmitting}
          onClick={onConfirm}>
          {t('signInSecurity.mfa.enrollDialog.confirm')}
        </RectangularButton>
        <Flex width='100%' paddingTop='large' justifyContent='center'>
          <Link data-test-mfa-enroll-modal-cancel-link onClick={closeModal}>
            {t('common.goBack')}
          </Link>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default MFAEnrollmentDialog;
